import { register, CloudObject, defineRelation, Direction } from 'olympe';

/**
 * @abstract
 * @extends {CloudObject}
 */
export default class FactorTarget extends CloudObject {

    /**
     * @abstract
     * @return {string}
     */
    getName() { /* empty */ }
}

// Hardcoded tags
register('01880b4019db96ba6603', FactorTarget);
FactorTarget.inverse_weightingFactortargetRel = defineRelation('01880b40d1795a00f94d', Direction.ORIGIN);
